import React, { useState } from "react";
import { TextFieldStyled } from "./styled";
import { FormHelperText, IconButton, InputAdornment } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";

const TextFieldBox = ({
  name,
  placeholder,
  required = false,
  variant = "outlined",
  fullWidth,
  type,
  handleChange,
  value,
  error,
  disabled,
  defaultValue,
  size = "medium",
  inputProps,
  sx,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((current) => !current);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <>
      <TextFieldStyled
        variant={variant}
        required={required}
        fullWidth={fullWidth}
        size={size}
        type={type === "password" ? (showPassword ? "text" : "password") : type}
        placeholder={placeholder}
        name={name}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        defaultValue={defaultValue}
        inputProps={inputProps}
        sx={sx}
        InputProps={{
          endAdornment: type === "password" && (
            <InputAdornment position="end">
              <IconButton
                aria-label={showPassword ? "Hide password" : "Show password"}
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
                size="small"
              >
                {showPassword ? (
                  <VisibilityOutlinedIcon fontSize="small" />
                ) : (
                  <VisibilityOffOutlinedIcon fontSize="small" />
                )}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      {error && error[name] && (
        <FormHelperText error={true}>{error[name]}</FormHelperText>
      )}
    </>
  );
};

export default TextFieldBox;
